var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',{key:_vm.componentRefresh,class:`badge badge-pill badge-${_vm.color}`,attrs:{"title":_vm.qaAble ? _vm.showIfHasPermission?.toString() : null}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }